import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Startpositie: centrum Antwerpen.
const ANTWERP: [number, number] = [51.2194, 4.4025];

type LatLng = { lat: number; lng: number };

// Eigen marker (Tailwind-token, geen externe afbeelding) zodat de standaard
// Leaflet-icoonbundeling geen roet in het eten gooit.
const markerIcon = L.divIcon({
  className: "",
  html:
    '<span class="block size-4 rounded-full bg-primary-600 ring-2 ring-white shadow-md"></span>',
  iconSize: [16, 16],
  iconAnchor: [8, 8],
});

function ClickHandler({ onPick }: { onPick: (p: LatLng) => void }): null {
  useMapEvents({
    click(event) {
      onPick({ lat: event.latlng.lat, lng: event.latlng.lng });
    },
  });
  return null;
}

// Interactieve kaart (Leaflet + OpenStreetMap): klik of versleep de marker om
// de plaatsingslocatie te kiezen. De coördinaten voeden de reverse geocoding.
export function MapPicker({
  point,
  onSelect,
}: {
  point: LatLng | null;
  onSelect: (point: LatLng) => void;
}): React.JSX.Element {
  return (
    <div className="h-72 w-full overflow-hidden rounded-lg border border-input">
      <MapContainer center={ANTWERP} zoom={12} scrollWheelZoom className="size-full">
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <ClickHandler onPick={onSelect} />
        {point ? (
          <Marker
            position={[point.lat, point.lng]}
            icon={markerIcon}
            draggable
            eventHandlers={{
              dragend(event) {
                const marker = event.target as L.Marker;
                const next = marker.getLatLng();
                onSelect({ lat: next.lat, lng: next.lng });
              },
            }}
          />
        ) : null}
      </MapContainer>
    </div>
  );
}
